import { CollectionReference, DocumentReference, QuerySnapshot } from "@firebase/firestore-types";
import * as moment from "moment";
import * as React from "react";
import { Component } from "react";
import { Glyphicon, Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LoadingStatus from "src/components/common/LoadingStatus";
import ExtendedAnnualSummaryByMonth from "src/components/projects/project/reports/extendedannualsummary/ExtendedAnnualSummaryByMonth";
import { round, TIMEOUT } from "src/global";
import { IDefaultProps } from "src/interfaces";
import fs from "src/services/config/fbConfig";
import {
  IExtendedAnnualSummaryByMonthReportPageState,
  IExtendedAnnualSummaryByMonthRow,
} from "./interfaces";

export default class ExtendedAnnualSummaryByMonthReportPage extends Component<
  IDefaultProps,
  IExtendedAnnualSummaryByMonthReportPageState
> {
  private projectDocument: DocumentReference;
  private statementsCollection: CollectionReference;
  private unsubscribe: any;
  public constructor(props: IDefaultProps) {
    super(props);

    this.state = {
      loading: true,
      annualSummaryByMonth: [],
      annualSummaryTotals: {
        avagEstimatedPower: 0,
        budgetPayment: 0,
        checkEstimate: false,
        electricBillAmount: 0,
        electricitySavings: 0,
        id: "",
        lastMonthOffPeakCredits: 0,
        lastMonthOnPeakCredits: 0,
        leasePayment: 0,
        metEstimatedGeneration: false,
        netElectricity: 0,
        netGridUsage: 0,
        netOffPeakElectricity: 0,
        netOnPeakElectricity: 0,
        numberOfDays: 0,
        offPeakFromGrid: 0,
        offPeakGenerated: 0,
        onPeakFromGrid: 0,
        onPeakGenerated: 0,
        percentSolarGenerated: 0,
        serviceEnd: Date.now(),
        serviceStart: Date.now(),
        solarDirectlyUsed: 0,
        statementDate: Date.now(),
        totalCost: 0,
        totalDelivered: 0,
        totalHouseholdUsage: 0,
        totalSolarGenerated: 0,
        totalSolarRecived: 0,
      },
    };

    this.renderNavbar = this.renderNavbar.bind(this);
    this.loadStatements = this.loadStatements.bind(this);
  }

  public componentWillMount() {
    const { appService } = this.props;
    const projectId = appService.getActiveProjectId();
    this.projectDocument = fs.fs.collection("projects").doc(projectId);
    this.statementsCollection = this.projectDocument.collection("statements");
    this.unsubscribe = this.statementsCollection
      .orderBy("statementDate")
      .onSnapshot(this.loadStatements);
  }

  public componentWillUnmount() {
    this.unsubscribe(this.loadStatements);
  }

  public render() {
    if (this.state.loading) {
      return <LoadingStatus text="Loading Report..." />;
    }

    return (
      <div className="statements-grid container-fixed-navbar">
        {this.renderNavbar()}
        <ExtendedAnnualSummaryByMonth
          appService={this.props.appService}
          projectLocation={this.props.appService.getActiveProjectLocation()}
          annualSummaryByMonth={this.state.annualSummaryByMonth}
          annualSummaryTotals={this.state.annualSummaryTotals}
        />
      </div>
    );
  }

  private loadStatements(querySnapshot: QuerySnapshot) {
    const rows: IExtendedAnnualSummaryByMonthRow[] = [];
    const totals: IExtendedAnnualSummaryByMonthRow = {
      avagEstimatedPower: 0,
      budgetPayment: 0,
      checkEstimate: false,
      electricBillAmount: 0,
      electricitySavings: 0,
      id: "",
      lastMonthOffPeakCredits: 0,
      lastMonthOnPeakCredits: 0,
      leasePayment: 0,
      metEstimatedGeneration: false,
      netElectricity: 0,
      netGridUsage: 0,
      netOffPeakElectricity: 0,
      netOnPeakElectricity: 0,
      numberOfDays: 0,
      offPeakFromGrid: 0,
      offPeakGenerated: 0,
      onPeakFromGrid: 0,
      onPeakGenerated: 0,
      percentSolarGenerated: 0,
      serviceEnd: Date.now(),
      serviceStart: Date.now(),
      solarDirectlyUsed: 0,
      statementDate: Date.now(),
      totalCost: 0,
      totalDelivered: 0,
      totalHouseholdUsage: 0,
      totalSolarGenerated: 0,
      totalSolarRecived: 0,
    };
    querySnapshot.forEach(doc => {
      if (doc.exists) {
        const {
          statementDate,
          serviceStartDate,
          serviceEndDate,
          totalAmountDue,
        } = doc.data() as any;

        const numberOfDays = round(
          moment.duration(moment(serviceEndDate).diff(moment(serviceStartDate))).asDays(),
          0
        );

        this.projectDocument
          .collection("simpleDualRateStatements")
          .doc(doc.id)
          .get()
          .then(simpleDoc => {
            const {
              lastMonthOffPeakCredit,
              lastMonthOnPeakCredit,
              onPeakElectricityCredited,
              onPeakElectricityFromGrid,
              solarGenerated,
              totalElectricityCredited,
              totalElectricityFromGrid,
            } = simpleDoc.data() as any;

            rows.push({
              id: doc.id,
              statementDate: statementDate ? statementDate : Date.now(),
              serviceStart: serviceStartDate ? serviceStartDate : Date.now(),
              serviceEnd: serviceEndDate ? serviceEndDate : Date.now(),
              numberOfDays,
              totalDelivered: totalElectricityFromGrid ? totalElectricityFromGrid : 0,
              onPeakFromGrid: onPeakElectricityFromGrid ? onPeakElectricityFromGrid : 0,
              offPeakFromGrid:
                totalElectricityFromGrid && onPeakElectricityFromGrid
                  ? totalElectricityFromGrid - onPeakElectricityFromGrid
                  : 0,
              totalSolarGenerated: solarGenerated ? solarGenerated : 0,
              onPeakGenerated: onPeakElectricityCredited ? onPeakElectricityCredited : 0,
              offPeakGenerated:
                totalElectricityCredited && onPeakElectricityCredited
                  ? totalElectricityCredited - onPeakElectricityCredited
                  : 0,
              lastMonthOnPeakCredits: lastMonthOnPeakCredit ? lastMonthOnPeakCredit : 0,
              lastMonthOffPeakCredits: lastMonthOffPeakCredit ? lastMonthOffPeakCredit : 0,
              netOffPeakElectricity:
                totalElectricityFromGrid -
                onPeakElectricityFromGrid -
                (totalElectricityCredited - onPeakElectricityCredited),
              netOnPeakElectricity:
                onPeakElectricityFromGrid && onPeakElectricityCredited
                  ? onPeakElectricityFromGrid - onPeakElectricityCredited
                  : 0,
              netGridUsage:
                totalElectricityFromGrid - totalElectricityCredited < 0
                  ? 0
                  : totalElectricityFromGrid - totalElectricityCredited,
              solarDirectlyUsed: solarGenerated - totalElectricityCredited,
              totalHouseholdUsage:
                totalElectricityFromGrid + (solarGenerated - totalElectricityCredited),
              percentSolarGenerated:
                (solarGenerated /
                  (totalElectricityFromGrid + (solarGenerated - totalElectricityCredited))) *
                100.0,
              electricBillAmount: totalAmountDue,
              totalSolarRecived: totalElectricityCredited,
              checkEstimate: false,
              avagEstimatedPower: 0,
              totalCost: 0,
              budgetPayment: 0,
              leasePayment: 0,
              electricitySavings: 0,
              metEstimatedGeneration: false,
              netElectricity: totalElectricityFromGrid - totalElectricityCredited,
            });
            totals.totalDelivered += rows[rows.length - 1].totalDelivered;
            totals.numberOfDays += rows[rows.length - 1].numberOfDays;
            totals.onPeakFromGrid += rows[rows.length - 1].onPeakFromGrid;
            totals.offPeakFromGrid += rows[rows.length - 1].offPeakFromGrid;
            totals.totalSolarGenerated += rows[rows.length - 1].totalSolarGenerated;
            totals.onPeakGenerated += rows[rows.length - 1].onPeakGenerated;
            totals.offPeakGenerated += rows[rows.length - 1].offPeakGenerated;
            totals.lastMonthOffPeakCredits += rows[rows.length - 1].lastMonthOffPeakCredits;
            totals.lastMonthOnPeakCredits += rows[rows.length - 1].lastMonthOnPeakCredits;
            if (rows[rows.length - 1].netOffPeakElectricity > 0) {
              totals.netOffPeakElectricity += rows[rows.length - 1].netOffPeakElectricity;
            }
            if (rows[rows.length - 1].netOnPeakElectricity > 0) {
              totals.netOnPeakElectricity += rows[rows.length - 1].netOnPeakElectricity;
            }
            totals.netGridUsage += rows[rows.length - 1].netGridUsage;
            totals.solarDirectlyUsed += rows[rows.length - 1].solarDirectlyUsed;
            totals.totalHouseholdUsage += rows[rows.length - 1].totalHouseholdUsage;
            totals.electricBillAmount += rows[rows.length - 1].electricBillAmount;
            if (rows[rows.length - 1].netElectricity > 0) {
              totals.netElectricity += rows[rows.length - 1].netElectricity;
            }
          });
      }
    });
    setTimeout(() => {
      this.setState({ loading: false, annualSummaryByMonth: rows, annualSummaryTotals: totals });
    }, TIMEOUT);
  }

  private renderNavbar() {
    const { appService } = this.props;
    const projectId = appService.getActiveProjectId();
    const projectLocation = appService.getActiveProjectLocation();
    return (
      <div className="statement-navbar-container">
        <Navbar>
          <Navbar.Header>
            <Navbar.Brand>
              <NavLink to={`/project/${projectId}`}>
                <Glyphicon glyph="glyphicon glyphicon-circle-arrow-left" className="button-right" />
                Back to {projectLocation}
              </NavLink>
            </Navbar.Brand>
          </Navbar.Header>
        </Navbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/reports/ExtendedAnnualSummaryByMonthReportPage.tsx